<template>
  <div>
    <CrudList
      title="Notificaciones"
      storeName="Push_notifications"
      :canAdd="user.user_role != 'admin_enterprise'"
      :canEdit="false"
      :canDelete="true"
      :role_admin_enterprise="user.user_role == 'admin_enterprise'"
      sortable
      next-link="/admin/banners"
      :breadcrumbs="[
        {
          text: 'Marketing y comunicación',
          disabled: false,
          href: '/admin/push_notifications'
        },
        {
          text: 'Notificaciones',
          disabled: false,
          href: '#'
        }
      ]"
    >
      <template v-slot:title="{ item }">
        <div class="table-cell-fixed">
          {{ item.title }}
        </div>
      </template>

    <template v-slot:created_at="{ item }">
      <div class="table-cell-fixed">
        {{ formatDate(item.created_at) }}
      </div>

    </template>
    </CrudList>
  </div>
</template>
<style>
.table-cell-fixed {
  min-height: 100px; /* altura mínima */
  max-height: 100px; /* altura fija */
  display: flex;
  align-items: center;
  overflow: hidden; /* evita desbordes */
}

.description-cell {
  font-size: 12px;       /* más pequeña */
  line-height: 1.2;      /* compacto */
  overflow-y: auto;      /* scroll si es muy larga */
  max-height: 100%;      /* respeta altura fija */
}
</style>

<script>
  import CrudList from "@/components/Crud/CrudList";
  import { mapState } from 'vuex';
  import CrudFormMixin from "@/mixins/crud_form";
  export default {
    mixins: [CrudFormMixin],
    components: {CrudList},
    computed: {
      ...mapState({
        user: state => state.Authenticate.user,
      }),
    },
    data(){
      return{
        role_enterprise: false, 
      }
    },
    async created() {
      const self = this;
      await self.$store.dispatch("Authenticate/me");
    },
  };
</script>
